import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiTrendingUp, FiTrendingDown, FiTarget, FiDollarSign, FiUsers } = FiIcons;

const FilterTabs = ({ activeFilter, onFilterChange }) => {
  const filters = [
    {
      id: 'all',
      label: 'ทั้งหมด',
      icon: FiUsers,
      description: 'สื่อโฆษณาทั้งหมด'
    },
    {
      id: 'high-performance',
      label: 'ประสิทธิภาพสูง',
      icon: FiTrendingUp,
      description: 'คะแนนเฉลี่ย > 80'
    },
    {
      id: 'high-roas',
      label: 'ROAS สูง',
      icon: FiDollarSign,
      description: 'ROAS เฉลี่ย > 5x'
    },
    {
      id: 'low-cpa',
      label: 'CPA ต่ำ',
      icon: FiTarget,
      description: 'CPA เฉลี่ย < 200'
    },
    {
      id: 'needs-improvement',
      label: 'ต้องปรับปรุง',
      icon: FiTrendingDown,
      description: 'คะแนนเฉลี่ย < 60'
    }
  ];

  return (
    <motion.div
      className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-6"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <h3 className="text-lg font-semibold text-gray-900 mb-4">กรองตามประสิทธิภาพ</h3>
      <div className="flex flex-wrap gap-3">
        {filters.map((filter) => (
          <motion.button
            key={filter.id}
            onClick={() => onFilterChange(filter.id)}
            className={`flex items-center space-x-2 px-4 py-3 rounded-lg border transition-all ${
              activeFilter === filter.id
                ? 'bg-blue-50 border-blue-200 text-blue-700'
                : 'bg-gray-50 border-gray-200 text-gray-700 hover:bg-gray-100'
            }`}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            <SafeIcon icon={filter.icon} className="h-4 w-4" />
            <div className="text-left">
              <div className="text-sm font-medium">{filter.label}</div>
              <div className="text-xs opacity-75">{filter.description}</div>
            </div>
          </motion.button>
        ))}
      </div>
    </motion.div>
  );
};

export default FilterTabs;